import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=ab11a714"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=ab11a714&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports